module.exports = Jsw.skinUrl + "/images/sticker-collection/sticker/yuppie.png?e115749c9296400aaf33335744f19654";